
import Icon from '@/components/UntitledUI/Icon.vue'
import Setting from '@/components/Settings/Setting'
import Button from '@/components/UntitledUI/Button'
import Tippy from '@/components/common/Tippy.vue'
import Badge from '@/components/UntitledUI/Badge.vue'

export default {
    name: 'TrustedDevices',
    components: { Button, Setting, Icon, Tippy, Badge },
    data () {
        return {
            loading: false,
            currentDevice: null,
            modal: false,
            devices: [],
            devicesForm: new this.$vForm({

            })
        }
    },
    computed: {
        isThisDeviceTrusted () {
            return this.devices.find(device => device.is_current)
        }
    },
    watch: {
        currentDevice (device) {
            if (device) {
                this.modal = 'remove'
            }
        }
    },
    created () {
        this.loadDevices()
    },
    methods: {
        loadDevices () {
            this.loading = true
            this.$axios.$get('/v1/settings/trustedDevices')
                .then((data) => {
                    this.devices = Array.isArray(data) ? data : []
                }).finally(() => { this.reset() })
        },
        formatDate (date) {
            date = new Date(date)
            const time = date.toLocaleString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            })

            return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${time}`
        },
        trustThisDevice () {
            this.$axios.$post('/v1/settings/trustedDevices')
                .then(() => {
                    this.loadDevices()
                    this.alertSuccess(this.$t('settings security trusted devices trust this device success'))
                }).catch(() => this.alertError())
            this.reset()
        },
        removeDevice () {
            this.loading = true
            this.$axios.$delete('/v1/settings/trustedDevices/' + this.currentDevice.id)
                .then(() => {
                    this.loadDevices()
                    this.alertSuccess(this.$t('settings security trusted devices remove device success'))
                }).catch(() => this.alertError())
            this.reset()
        },
        reset () {
            this.modal = this.loading = this.currentDevice = null
        },
        alertSuccess (body) {
            this.$refs.settings.alert({ type: 'success', body })
        },
        alertError () {
            this.$refs.settings.alert({ type: 'danger', body: this.$t('general error please try again') })
        }
    }

}
